export default __webpack_public_path__ + "static/media/ocean-export-dark.a064ec0a.svg";